import { MutationTree, ActionTree } from 'vuex';
import { fabric } from 'fabric';
import { FotowandCanvasManager } from '../lib/CanvasManager/FotowandCanvasManager';
import { Design } from '@/types';

// const manager: FotowandCanvasManager = new FotowandCanvasManager();

export const namespaced = true;

interface CanvasState {
  manager: FotowandCanvasManager;
  selected: boolean;
}

export const state = () => ({
  manager: new FotowandCanvasManager(),
  selected: null,
});

export const mutations: MutationTree<CanvasState> = {
  removeObject({ manager }, object: fabric.Object) {
    manager.removeObject(object);
    this.commit('design/setDesign', manager.toDesign());
  },
  bringForward({ manager }, object: fabric.Object) {
    manager.bringForward(object);
    this.commit('design/setDesign', manager.toDesign());
  },
  sendToBack({ manager }, object: fabric.Object) {
    manager.sendToBack(object);
    this.commit('design/setDesign', manager.toDesign());
  },
  async addImage({ manager }, src: string | File) {
    await manager.addImage(src);
    this.commit('design/setDesign', manager.toDesign());
    manager.objectLoaded();
  },
  setDesign({ manager }) {
    this.commit('design/setDesign', manager.toDesign());
  },
  async loadDesign(state, design: Design) {
    await state.manager.load(design);
    // this.commit('design/setDesign', manager.toDesign());
  },
  rotateObject({ manager }, { object, angle }: { object: fabric.Object; angle: number }) {
    object.rotate(object.angle + angle);
    if (object.data.type === 'Background') {
      manager.relocateBackground(true);
    }
    manager.canvas.requestRenderAll();
  },
};

export const actions: ActionTree<CanvasState, unknown> = {
  toDesign({ state }) {
    return state.manager.toDesign();
  },
};
